import * as AuthApi from '../api/AuthRequest'
import { logVisitorConnectionDetails } from '../tools/visitorConnection'
import { getItemFeed } from './ItemAction'
import { getCategoryFeed } from './ItemAction'
import { getDataFeed } from './DataFeedAction'
import { getActionFeed } from './UserFeedAction'
import { getUserFeed } from './UserFeedAction'

export const logIn = (formData) => async(dispatch) => {
    
    dispatch({type: "AUTH_START"})
    try {
        const {data} = await AuthApi.logIn(formData)
        logVisitorConnectionDetails({activity: "login_connection", userId: data.user._id, username: data.user.username, page: 'ns_auth'})
        const storedIntent = sessionStorage.getItem('deepLinkIntent');
        if (storedIntent) {
            const deepLinkIntent = JSON.parse(storedIntent);
            sessionStorage.removeItem('deepLinkIntent');
            dispatch({ type: "SET_DEEP_LINK_INTENT", payload: deepLinkIntent });
        }
        dispatch({type: "AUTH_SUCCESS", data: data})
    } catch (error) {
        console.log(error);
        dispatch({type: "AUTH_FAIL", status: error})
    }
}

export const signUp = (formData) => async(dispatch) => {
    
    dispatch({type: "AUTH_START"})
    try {
        const {data} = await AuthApi.signUp(formData)
        logVisitorConnectionDetails({activity: "login_connection", userId: data.user._id, username: data.user.username, page: 'ns_auth'})
        dispatch({type: "AUTH_SUCCESS", data: data})
    } catch (error) {
        console.log(error)
        dispatch({type: "AUTH_FAIL", status: error})
    }
}

export const forgotPass = (email) => async(dispatch) => {
    
    dispatch({type: "AUTH_FORGOT_PASS_START"})
    try {
        const {data} = await AuthApi.forgotPass(email)
        dispatch({type: "AUTH_FORGOT_PASS_SUCCESS", data: data, message: data.message})
    } catch (error) {
        console.log(error)
        console.log(error.response.status);
        const status = error.response?.status;
        const message = error.response?.data?.message || "Something went wrong";
        dispatch({type: "AUTH_FORGOT_PASS_FAIL", status, message})
    }
}

export const resetPass = (passData) => async(dispatch) => {
    
    dispatch({type: "AUTH_RESET_PASS_START"})
    try {
        const {data} = await AuthApi.resetPass(passData)
        dispatch({type: "AUTH_RESET_PASS_SUCCESS", data: data})
    } catch (error) {
        console.log(error)
        console.log(error.response.status);
        dispatch({type: "AUTH_RESET_PASS_FAIL", status: error.response.status})
    }
}

export const updatePass = (formData) => async(dispatch) => {
    
    dispatch({type: "AUTH_UPDATE_PASS_START"})
    try {
        const {data} = await AuthApi.updatePass(formData)
        dispatch({type: "AUTH_UPDATE_PASS_SUCCESS", data: data})
    } catch (error) {
        console.log(error)
        console.log(error.response.status);
        dispatch({type: "AUTH_UPDATE_PASS_FAIL", status: error.response.status})
    }
}

export const refreshAuthData = (userData) => async(dispatch) => {
    dispatch({type: "AUTH_REFRESH_START"})
    try {
        const userType = userData.user.userType;

        // Simplified action lookup
        const actionMap = { 0: "follow", 1: "subscribe", 2: "subscribe" };
        const followAction = actionMap[userType] || "follow";

        const { data } = await AuthApi.refreshAuthData(userData);
        const userId = data.userData._id;

        dispatch({ type: "AUTH_REFRESH_SUCCESS", data: data.userData });
        dispatch(getItemFeed(userId, null));
        dispatch(getCategoryFeed(userId, null, null, null));
        dispatch(getDataFeed(userId, null));
        dispatch(getActionFeed(userId, followAction));
        dispatch(getUserFeed(userId, null));

    } catch (error) {
        console.log(error);
        dispatch({ type: "AUTH_REFRESH_FAIL", status: error.response.status });
    }
}

export const addUserSheet = (sheetData) => async(dispatch) => {
    dispatch({type: "ON_SHEET_ADD", data: sheetData})
}

export const clearAuthError = () => async(dispatch) => {
    
    dispatch({type: "AUTH_CLEAR_ERROR"})
}

export const logOut = () => async(dispatch) => {
    dispatch({type: "LOG_OUT"})
}